const isElement = (el) => el && el.nodeType === Node.ELEMENT_NODE

export const removeFromDom = (el) => {
  isElement(el) && isElement(el.parentNode) && el.parentNode.removeChild(el)
}

export const scrollToSelector = (selector, option) => {
  const el = document.querySelector(selector)
  if (isElement(el)) {
    const _option = option || {
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    }
    el.scrollIntoView(_option)
  }
}
